export class MediaFileAssociationCommandModel {
    public mediaFileAssociationId: string;
    public associationId: string;
    public entityName: string;
    public mediaUseCode: string;
    public mediaId: string;
}